import * as React from "react";
const SvgPlay = () => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M3.892 16.829q.253 0 .486-.097.234-.088.496-.243l10.813-6.282q.545-.301.749-.545a.9.9 0 0 0 .214-.602.85.85 0 0 0-.214-.584q-.204-.252-.749-.564L4.874 1.64a3 3 0 0 0-.496-.243 1.3 1.3 0 0 0-.486-.097q-.486 0-.768.34-.272.34-.272.905v13.04q0 .563.272.904.282.34.768.34"
  }
));
export default SvgPlay;
